import script from "./TraitRanksApesTraitsTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitRanksApesTraitsTabs.vue?vue&type=script&setup=true&lang=js"

import "./TraitRanksApesTraitsTabs.vue?vue&type=style&index=0&id=20e390ce&lang=scss"

const __exports__ = script;

export default __exports__